// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAUwSikEBtf891yzz8x76B-GSjB6z53xo0",
  authDomain: "eprday.firebaseapp.com",
  projectId: "eprday",
  storageBucket: "eprday.appspot.com",
  messagingSenderId: "882530699618",
  appId: "1:882530699618:web:bf41e5a70063cfe1ce843b",
  measurementId: "G-PKL2Y0C9E8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const authService = getAuth(app);
export const db = getFirestore(app);